export const Terms = {
  privacy:
    "https://www.notion.so/DropshipTool-s-Privacy-Policy-1dc0c13273a280f9b5cfc58b7b6430ef",
  terms:
    "https://www.notion.so/DropshipTool-s-Terms-of-Service-1dc0c13273a2809e8421c512a0cd7b45",
  refund:
    "https://www.notion.so/What-is-DropshipTool-s-Refund-Policy-1d80c13273a2815fabd3ef4977c0adf4",
};
